/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-01-30 15:01:22
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-05-18 10:48:58
 * @FilePath: \h5-lcjc-formula\src\utils\category\Anae.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 麻醉学 */

/** 对应的标题 */
const categoryMap = {
  Bromage: 'Bromage 分级',
  BromageModified: 'Bromage 分级 （Breen 改良版）',
  Mallampati: '改良Mallampati分级',
  Charlson: 'Charlson 共病指数',
  AllowableBloodLoss: '最大失血量',
  APACHE2: 'APACHE II',
  Goldman: 'Goldman（多因素）指数',
  Detsky: 'Detsky 指数（改良版）',
  IVDripRate: '静脉补液滴速',
  Lee: 'Lee 评分（修订版）',
  DeltaPP: '脉压差异',
  Possum: 'Possum 和 P-Possum 评分',
  RSBI: '浅快呼吸指数',
  TASH: 'TASH 评分',
  ASCVD: '心血管风险 （ACC/AHA）',
  // 'ABG':'动脉血气分析',
  ASA_AnesthesiaRisk: 'ASA麻醉风险评分',
  Aldrete: '改良Aldrete评分',
  Steward: 'Steward苏醒评分表',
  PADSS: 'PADSS评分',
  Anesthesia: '常用局麻药的剂量及浓度',
  SpinalAnesthesia: '蛛网膜下腔阻滞常用药物',
  CormackLehane: 'Cormack-Lehane分级',
  PrinceHenry: 'Prince-Henry疼痛评分',
  InhalationOfGeneralAnesthesia: '麻醉通气系统'
}
/** 对应的描述 */
const categoryDescMap = {
  Bromage: '评估积水麻醉阻滞情况',
  BromageModified: '评估积水麻醉阻滞情况',
  Mallampati: '评估气管插管难易程度',
  Charlson: '死亡风险',
  AllowableBloodLoss: '最多失血量多少是安全的？',
  APACHE2: 'ICU 疾病严重度',
  Goldman: 'Goldman（多因素）指数',
  Detsky: '非心脏手术风险',
  IVDripRate: '根据每毫升滴数、总量和时间计算',
  Lee: '非心脏手术风险',
  DeltaPP: '补液试验反应测试',
  Possum: '生理学和手术严重性评分',
  RSBI: '脱机',
  TASH: '创伤患者大量输血概率',
  ASCVD: '汇总 10 年 ASCVD 风险',
  // 'ABG':'血气分析结果解析',
  ASA_AnesthesiaRisk: '预测麻醉和手术危险程度',
  Aldrete: '常用的麻醉后评分体系',
  Steward: '评估患者是否转出麻醉监护室',
  PADSS: '麻醉后出院评分系统',
  Anesthesia: '',
  PrinceHenry: '胸腹部手术后疼痛评估',
  InhalationOfGeneralAnesthesia: '吸入全身麻醉的方式及特点'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Anae.js